export const spLotGridColumns = {
    "Material ID": true,
    "Trial ID": true,
    "Pollination ID": true,
    "Bags": true,
    "Fruit Weight (g)": true,
    "Fruit Count": true,
    "Registered Container": true,
    "Status": true,
    "Priority": true,
    "Last Updated On": true,    
    "Remarks": true,
    "Actions": true
};

export const HIGH_PRIORITY_VALUE = ['High'];